;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "vi3ose8uvcs"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {

    $(this).find('.lh-accordion-section').each(function(e){

        var t = $(this);

        t.find('.lh-accordion-item .lh-header').on('click', function () {

             <!--t.find('.lh-accordion-item').not($(this)).removeClass('active');-->

             $(this).parent().toggleClass('active');

        })
         document.getElementById("title-aula").style.color = "#ff0000";
    });
    
   

 };						cb.bind($('section[data-section-id="vi3ose8uvcs"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="vi3ose8uvcs"]').get(0))({						url: "https://library.layouthub.com/HUB/files/Tm92LS0yMDE5/NTc0ODY0ODc5/First_release/pages/Faqs2/Faqs/",						settings: {}					}, jQuery);})(jQuery);;console.log('This page layout has been built by https://www.layouthub.com');